export const navigationLinks = [
    { title: "Меню", id: "menu" },
    { title: "Карта", id: "map" },
    { title: "Акции", id: "promo" },
    { title: "Оставить отзыв", id: "feedback" },
];
